import React, { useState } from 'react';

import { Divider, Spinner } from '../../BaseUI';
import ProfileSwitchSetting from './ProfileSwitchSetting';
import PromptForNameModal from './PromptForNameModal';

const Directory = ({
  isLoading,
  userId,
  profileEnabled,
  messageEnabled,
  mentioningDisabled,
  messagingBlocked,
}) => {
  const [showPromptForName, setShowPromptForName] = useState(false);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="section-container" id="Settings">
          <div className="section-header">Directory Settings</div>
          <ProfileSwitchSetting
            userId={userId}
            value={profileEnabled}
            sanitizedFieldName="profile_enabled"
            description="Enable my profile"
            hint="Having a profile in The Information's subscriber directory allows you to look up and
            interact with other subscribers, leave comments, and more."
            handleError={() => setShowPromptForName(true)}
          />
          {!messagingBlocked && (
            <>
              <Divider />
              <ProfileSwitchSetting
                userId={userId}
                value={messageEnabled}
                sanitizedFieldName="message_enabled"
                description="Allow direct messages"
                hint="Your email won't be shared with other subscribers. When other subscribers want to reach out they can send a message from your profile and we will forward it."
              />
            </>
          )}
          <Divider />
          <ProfileSwitchSetting
            userId={userId}
            value={mentioningDisabled}
            sanitizedFieldName="mentioning_disabled"
            description="Allow comment mentions"
            hint="Allow other subscribers to mention you in comments on The Information articles."
            hasOppositeValue
          />
          <Divider />
        </div>
      )}
      <PromptForNameModal
        userId={userId}
        isOpen={showPromptForName}
        onClose={() => setShowPromptForName(false)}
      />
    </>
  );
};

export default Directory;
